import { SceneType } from '@rootTypes/common';

export function getPageTitle(verificationScene: SceneType | null, isAdmin?: boolean): string {
  switch (verificationScene) {
    case SceneType.INVITATION:
      return isAdmin ? 'New Admin Setup' : 'New User Setup';
    case SceneType.RESET_PASSWORD:
      return 'Reset Password';
    case SceneType.FORGOT_PASSWORD:
      return 'Forgot Password';
    default:
      return 'Login';
  }
}

export default getPageTitle;
